import styled from "styled-components";

export const HomeWrapper = styled.div`
  width: 100%;
  height: 100%;
`;
